import { Key } from "./utils/keys";

export const Color = {
    [Key.light]:{
        primary: "#ececec",
        primaryText: "#161616",
        secondary: "#ffffff",
        secondaryText: "#000000",
        positive: "#2a53da",
        positiveText: "#ffffff",
        negative: "#be0e0e",
        negativeText: "#ffffff",
    },
    [Key.dark]:{
        primary: "#12121f",
        primaryText: "#e4e4e4",
        secondary: "#13131b",
        secondaryText: "#f7f7f7",
        positive: "#6581dd",
        positiveText: "#0e0e0e",
        negative: "#e76363",
        negativeText: "#111111",
    }
}